import { render, staticRenderFns } from "./GetQuestionSelo.vue?vue&type=template&id=0e08d01e&scoped=true"
import script from "./GetQuestionSelo.vue?vue&type=script&lang=js"
export * from "./GetQuestionSelo.vue?vue&type=script&lang=js"
import style0 from "./GetQuestionSelo.vue?vue&type=style&index=0&id=0e08d01e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e08d01e",
  null
  
)

export default component.exports